import { useState } from 'react'
import { useCreateTrackValue, useUpdateTrackValue } from '@/features/contract/statuses/hooks'
import type { StatusTrackValue } from '@/features/contract/statuses/types'
import { DialogShell } from './DialogShell'
import { CODE_REGEX, formatError } from './formatError'

export function ValueFormDialog({ trackId, editing, onClose }: {
  trackId: number
  editing: StatusTrackValue | null
  onClose: () => void
}) {
  const create = useCreateTrackValue()
  const update = useUpdateTrackValue()
  const [code, setCode] = useState(editing?.code ?? '')
  const [labelPl, setLabelPl] = useState(editing?.labelPl ?? '')
  const [isActive, setIsActive] = useState(editing?.isActive ?? true)
  const [error, setError] = useState<string | null>(null)

  const submit = () => {
    setError(null)
    if (!editing && !CODE_REGEX.test(code)) { setError('Code: małe litery, cyfry, podkreślenia. Musi zaczynać się od litery.'); return }
    if (!labelPl.trim()) { setError('Etykieta nie może być pusta.'); return }
    const sortOrder = editing?.sortOrder ?? 1_000_000  // appended at the end; reorder via DND afterwards
    if (editing) {
      update.mutate({ trackId, valueId: editing.id, payload: { labelPl, sortOrder, isActive } },
        { onSuccess: onClose, onError: e => setError(formatError(e)) })
    } else {
      create.mutate({ trackId, payload: { code, labelPl, sortOrder, isActive } },
        { onSuccess: onClose, onError: e => setError(formatError(e)) })
    }
  }

  const isSubmitting = create.isPending || update.isPending

  return (
    <DialogShell
      title={editing ? `Edycja wartości ${editing.code}` : 'Nowa wartość'}
      onClose={onClose}
      isSubmitting={isSubmitting}
      error={error}
      onSubmit={submit}
    >
      <label className="grid gap-1">
        <span className="text-xs uppercase text-slate-500">Kod</span>
        <input value={code} onChange={e => setCode(e.target.value)} disabled={!!editing || isSubmitting} className="border rounded px-2 py-1 font-mono" />
      </label>
      <label className="grid gap-1">
        <span className="text-xs uppercase text-slate-500">Etykieta</span>
        <input value={labelPl} onChange={e => setLabelPl(e.target.value)} disabled={isSubmitting} className="border rounded px-2 py-1" />
      </label>
      <label className="flex items-center gap-2">
        <input type="checkbox" checked={isActive} onChange={e => setIsActive(e.target.checked)} disabled={isSubmitting} />
        <span>Aktywne</span>
      </label>
      <p className="text-[11px] text-slate-500">
        Kolejność ustawisz po zapisaniu - przeciągając wartości na liście.
      </p>
    </DialogShell>
  )
}
